<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="generateQrCodeModal"
      persistent
      max-width="620px"
    >
      <v-card>
        <v-card-title>
          <div class="col-sm-2 col-md-2 col-md-offset-10">
            <v-btn
              flat
              @click="closeGenerateQrCodeModal()"
              class="close"
              id="close-button"
            ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div id="printArea" ref="printAreaRef">
            <div
              v-for="(qr, index) in qrCodeValues"
              :key="index"
              class="barcode-row"
            >
              <div class="barcode-qr">
                <qr-code
                  :text="driverDeliverUrl(qr[0])"
                  :size="60"
                ></qr-code>
                <p style="text-align: center; margin: 0; font-size: 10px"><b>{{ $t('qrLabels.driverLabel') }}</b></p>
              </div>
              <div class="barcode-info">
                <p><b>{{ $t('columns.orderId') }}: </b>{{ qr[4] }}</p>
                <p class="customer-name"><b>{{ $t('columns.name') }}: </b>{{ qr[1] }}</p>
                <p><b>{{ $t('columns.phone') }}: </b>{{ qr[2] }}</p>
                <p><b>{{ $t('qrLabels.productLabel') }}: </b>{{ qr[qr.length - 1] }}</p>
              </div>
              <div class="barcode-qr">
                <qr-code
                  :text="qr[0].toString()"
                  :size="60"
                ></qr-code>
                <p style="text-align: center; margin: 0"><b>{{ qr[0] }}</b></p>
                <div
                  v-if="qr[5] === '1'"
                  class="ship-only-badge"
                >
                  {{ $t('columns.shipOnly') }}
                </div>
              </div>
              <div style="page-break-before: always"></div>
            </div>
          </div>

          <div class="text-xs-right mt-2 mb-1">
            <v-btn
              id="print-button"
              @click="printMe()"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>

          <hr class="label-divider" />

          <div class="label-columns">
            <div class="label-column">
              <div id="printAreaDriver" ref="printAreaDriver">
                <div
                  v-for="(qr, index) in qrCodeValues"
                  :key="'driver-' + index"
                  class="label-card"
                >
                  <p class="label-name">{{ qr[1] }}</p>
                  <div class="label-qr">
                    <qr-code
                      :text="driverDeliverUrl(qr[0])"
                      :size="180"
                    ></qr-code>
                  </div>
                <p class="label-price">{{ $t('columns.price') }} : {{ qr[qrPriceIndex] ? Number(qr[qrPriceIndex]).toFixed(2) : '0.00' }} $</p>
                <p class="label-order-id"><span>CID: {{ qr[3] }}</span></p>
                <p class="label-order-id"><span>OID: {{ qr[4] }}</span></p>
              </div>
            </div>
              <div class="text-xs-center mt-1">
                <v-btn
                  id="print-label-driver-button"
                  @click="printLabel('printAreaDriver')"
                  style="height:auto"
                  outline
                  color="teal"
                >{{ $t('qrLabels.printLabelDriverButton') }}</v-btn>
              </div>
            </div>

            <div class="label-column">
              <div id="printAreaOrderId" ref="printAreaOrderId">
                <div
                  v-for="(qr, index) in qrCodeValues"
                  :key="'orderid-' + index"
                  class="label-card"
                >
                  <p class="label-name">{{ qr[1] }}</p>
                  <div class="label-qr">
                    <qr-code
                      :text="qr[4]"
                      :size="180"
                    ></qr-code>
                  </div>
                <p class="label-price">{{ $t('columns.price') }} : {{ qr[qrPriceIndex] ? Number(qr[qrPriceIndex]).toFixed(2) : '0.00' }} $</p>
                <p class="label-order-id"><span>CID: {{ qr[3] }}</span></p>
                <p class="label-order-id"><span>OID: {{ qr[4] }}</span></p>
              </div>
            </div>
              <div class="text-xs-center mt-1">
                <v-btn
                  id="print-label-orderid-button"
                  @click="printLabel('printAreaOrderId')"
                  style="height:auto"
                  outline
                  color="deep-orange"
                >{{ $t('qrLabels.printLabelOrderIdButton') }}</v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: [
    'generateQrCodeModal',
    'closeGenerateQrCodeModal',
    'qrCodeValues',
    'generateQrCode',
    'getResults',
    'advanceToIntShipment',
    // Index of total_amount within each qrCodeValues row. qrCodeValues is a shared,
    // positional array whose shape is dictated by other consumers on the parent page
    // (e.g. branchDeliveredOrder.vue's openOrderInvoiceModal() already claims index 10
    // for is_ship_only and 11 for total_amount) — so this can't just always be 10.
    // Defaults to 10, which matches allOrder.vue and purchasedOrder.vue as-is.
    'priceIndex'
  ],

  data() {
    return {
      size: 60,
      generateQrCodeUrl: 'api/generate_qrcode',
      advanceToIntShipmentUrl: 'api/advance_to_int_shipment'
    }
  },

  computed: {
    qrPriceIndex() {
      return this.priceIndex !== undefined ? this.priceIndex : 10
    }
  },

  watch: {
    // The QR codes themselves render purely from already-loaded order data (see the
    // qr-code components in the template) — this call only persists orders.qrcode
    // server-side, which userDeliveringMultipleOrder()'s "Send to Customer" bulk action
    // later depends on. Fires when the modal opens (the user's actual "generate" intent),
    // not on close — previously this only ran if/when the close button was clicked, which
    // was itself a bug (see close button's @click).
    generateQrCodeModal(isOpen) {
      if (isOpen) this.persistQrCodes()
    }
  },

  methods: {
    driverDeliverUrl(orderId) {
      return window.location.origin + '/driver-deliver/' + orderId
    },

    persistQrCodes() {
      let token = localStorage.getItem('access_token')

      // Deliberately no .then(this.getResults) here: getResults() (in every parent page)
      // clears qrCodeValues as its first line, and this modal's own printArea/printAreaDriver/
      // printAreaOrderId render straight off that same qrCodeValues prop — calling it while the
      // modal is still open wipes the labels out from under the user right after they open it.
      // The table refresh instead happens in closeGenerateQrCodeModal(), once the modal (and its
      // dependency on qrCodeValues) is actually going away.
      axios
        .put(this.generateQrCodeUrl, this.qrCodeValues, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .catch(error => {
          const msg = (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : this.$t('qrLabels.failedToGenerateQrCode')
          swal(this.$t('common.error'), msg, 'error')
        })
    },

    // Extract the QR data-URL from a label-card synchronously.
    // canvas.toDataURL() works even when the canvas is display:none — the pixel
    // buffer is intact. Falls back to the library's <img> src if canvas is absent.
    getQrSrc: function (card) {
      if (!card) return null
      var canvas = card.querySelector('canvas')
      if (canvas) {
        try { return canvas.toDataURL('image/png') } catch (e) {}
      }
      var img = card.querySelector('img')
      return (img && img.src) ? img.src : null
    },

    // Shared portal print logic.
    _printPortal: function (pagesHtml) {
      var portal = document.getElementById('labelPrintPortal')
      if (!portal) {
        portal = document.createElement('div')
        portal.id = 'labelPrintPortal'
        document.body.appendChild(portal)
      }
      portal.innerHTML = pagesHtml
      portal.style.cssText = 'display:block;position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;z-index:99999;overflow-y:auto;'

      var printStyle = document.getElementById('labelPrintStyle')
      if (!printStyle) {
        printStyle = document.createElement('style')
        printStyle.id = 'labelPrintStyle'
        document.head.appendChild(printStyle)
      }
      printStyle.textContent = [
        '@page { margin: 5mm; }',
        '@media print {',
        '  body > *:not(#labelPrintPortal) { display: none !important; }',
        '  #labelPrintPortal { position: static !important; overflow: visible !important; height: auto !important; }',
        '  img { border: 0 !important; outline: 0 !important; box-shadow: none !important; margin: 0 !important; padding: 0 !important; }',
        '  * { -webkit-print-color-adjust: exact; color-adjust: exact; }',
        '}'
      ].join('\n')

      var toHide = Array.from(document.body.children).filter(function (el) { return el !== portal })
      toHide.forEach(function (el) { el.style.setProperty('display', 'none', 'important') })

      var cleanup = function () {
        toHide.forEach(function (el) { el.style.removeProperty('display') })
        portal.style.display = 'none'
        portal.innerHTML = ''
        printStyle.textContent = ''
        window.removeEventListener('afterprint', cleanup)
      }
      window.addEventListener('afterprint', cleanup)
      window.print()
    },

    printMe() {
      var self   = this
      var pages  = []
      var QR_IMG = 'display:block;width:100%;height:auto;margin:0;padding:0;border:0;outline:0;box-shadow:none;image-rendering:pixelated;image-rendering:-moz-crisp-edges;image-rendering:crisp-edges;'

      for (var i = 0; i < self.qrCodeValues.length; i++) {
        var qr = self.qrCodeValues[i]
        if (!qr) continue

        var driverArea = self.$refs.printAreaDriver
        var orderArea  = self.$refs.printAreaOrderId
        var driverCards = driverArea ? driverArea.querySelectorAll('.label-card') : []
        var orderCards  = orderArea  ? orderArea.querySelectorAll('.label-card')  : []

        var driverSrc = self.getQrSrc(driverCards[i] || null)
        var orderSrc  = self.getQrSrc(orderCards[i]  || null)
        if (!driverSrc && !orderSrc) continue

        var name       = String(qr[1] || '').replace(/</g, '&lt;')
        var phone      = String(qr[2] || '').replace(/</g, '&lt;')
        var orderId    = String(qr[4] || '').replace(/</g, '&lt;')
        var customerId = String(qr[3] || '').replace(/</g, '&lt;')
        var isShipOnly = qr[5] === '1'

        var col = function (src, label) {
          if (!src) return ''
          return '<div style="flex:1;min-width:0;margin:0;padding:0;">' +
            '<p style="margin:0;padding:0;font-size:11px;font-weight:bold;text-align:center;line-height:1.4;">' + label + '</p>' +
            '<img src="' + src + '" style="' + QR_IMG + '">' +
          '</div>'
        }

        pages.push(
          '<div style="margin:0;padding:4px;box-sizing:border-box;page-break-after:always;break-after:page;background:#fff;">' +
            '<div style="display:flex;width:100%;margin:0;padding:0;gap:4px;">' +
              col(driverSrc, self.$t('qrLabels.driverLabel')) +
              col(orderSrc, orderId + (isShipOnly ? ' &middot; ' + self.$t('columns.shipOnly') : '')) +
            '</div>' +
            '<div style="margin-top:4px;padding-top:3px;font-size:12px;line-height:1.6;border-top:1px solid #ccc;display:flex;flex-wrap:wrap;gap:0 14px;">' +
              '<span><b>' + self.$t('columns.name') + ':</b> ' + name + '</span>' +
              '<span><b>OID:</b> ' + orderId + '</span>' +
              '<span><b>CID:</b> ' + customerId + '</span>' +
              '<span><b>' + self.$t('columns.phone') + ':</b> ' + phone + '</span>' +
            '</div>' +
          '</div>'
        )
      }

      if (!pages.length) return
      if (self.advanceToIntShipment) self.doAdvanceToIntShipment()
      self._printPortal(pages.join(''))
    },

    printLabel(areaId) {
      var self  = this
      var area  = self.$refs[areaId]
      var cards = area ? area.querySelectorAll('.label-card') : []
      if (!cards.length) return

      var pages  = []
      var QR_IMG = 'display:block;width:100%;height:auto;margin:0;padding:0;border:0;outline:0;box-shadow:none;image-rendering:pixelated;image-rendering:-moz-crisp-edges;image-rendering:crisp-edges;'

      for (var i = 0; i < cards.length; i++) {
        var qr = self.qrCodeValues[i]
        if (!qr) continue

        var src = self.getQrSrc(cards[i])
        if (!src) continue

        var name       = String(qr[1]  || '').replace(/</g, '&lt;')
        var price      = qr[self.qrPriceIndex] ? Number(qr[self.qrPriceIndex]).toFixed(2) : '0.00'
        var customerId = String(qr[3]  || '').replace(/</g, '&lt;')
        var orderId    = String(qr[4]  || '').replace(/</g, '&lt;')

        // No rotation — user prints landscape so content fills the full width naturally.
        // page-break-inside:avoid keeps all text together and prevents OID jumping to
        // the next page regardless of the browser zoom level.
        pages.push(
          '<div style="margin:0;padding:6mm;box-sizing:border-box;page-break-after:always;break-after:page;' +
                      'page-break-inside:avoid;break-inside:avoid;background:#fff;text-align:center;">' +
            '<p style="font-size:72px;font-weight:bold;text-transform:uppercase;' +
                      'margin:0 0 6px;word-break:break-word;line-height:1.2;">' + name + '</p>' +
            '<img src="' + src + '" style="' + QR_IMG + '">' +
            '<p style="font-size:50px;margin:6px 0 3px;">' + self.$t('columns.price') + ' : ' + price + ' $</p>' +
            '<p style="font-size:50px;font-weight:bold;letter-spacing:0.5px;margin:0 0 3px;">CID: ' + customerId + '</p>' +
            '<p style="font-size:50px;font-weight:bold;letter-spacing:0.5px;margin:0;">OID: ' + orderId + '</p>' +
          '</div>'
        )
      }

      if (!pages.length) return
      if (self.advanceToIntShipment) self.doAdvanceToIntShipment()
      self._printPortal(pages.join(''))
    },

    doAdvanceToIntShipment() {
      let token = localStorage.getItem('access_token')
      const orderIds = this.qrCodeValues.map(q => q[0])

      // Same reasoning as persistQrCodes(): no .then(this.getResults) here. Print doesn't
      // close the modal, so qrCodeValues is still bound to the on-screen labels — clearing
      // it here (getResults()'s first line) made the QR codes vanish right after printing.
      // closeGenerateQrCodeModal() refreshes the table once the modal actually closes.
      axios
        .put(this.advanceToIntShipmentUrl, { orders_id: orderIds }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .catch(err => {
          const msg = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : this.$t('qrLabels.failedToAdvanceToIntShipment')
          swal(this.$t('common.warning'), msg, 'warning')
        })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}

.barcode-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 0;
  margin-bottom: 3px;
}
.barcode-row:not(:first-child) {
  padding-top: 10px;
}

.barcode-info {
  flex: 1;
  min-width: 0;
}

.barcode-info p {
  margin: 0;
  font-size: 14px !important;
  line-height: 2rem !important;
}

.barcode-info .customer-name {
  white-space: pre-wrap;
}

.barcode-qr {
  flex-shrink: 0;
  text-align: center;
}


.ship-only-badge {
  border: 2px solid black;
  border-radius: 4px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  margin-top: 4px;
}

#printArea {
  background-color: white;
}

.label-divider {
  border: none;
  border-top: 1px solid #ccc;
  margin: 16px 0 12px;
}

.label-columns {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.label-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label-card {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 10px;
  padding: 16px 12px 12px;
  text-align: center;
  width: 230px;
  margin-bottom: 16px;
  page-break-inside: avoid;
}

.label-name {
  font-size: 17px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0 0 10px;
  word-break: break-word;
  line-height: 1.3;
}

.label-qr {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.label-price {
  font-size: 14px;
  margin: 0 0 6px;
}

.label-order-id {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  margin: 0;
}

/*table {*/
/*page-break-inside:auto*/
/*}*/

/*tr {*/
/*page-break-inside:avoid; page-break-after:auto*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/createQrCode.vue